import { store } from 'store';
import { Address, erc20Abi, zeroAddress } from 'viem';
import { useReadContract } from 'wagmi';

type Props = {
  chainId: number | undefined;
  tokenAddress: Address | null | undefined;
  spenderAddress: Address | undefined;
  refetchIntervalSec?: number | false;
  enabled?: boolean;
};

export const useTokenAllowance = (props: Props) => {
  const { chainId, tokenAddress, spenderAddress, refetchIntervalSec } = props;
  const { account } = store.web3Store;

  const isNative = !!chainId && tokenAddress === zeroAddress;
  const enabled =
    props.enabled !== false && !!(account && tokenAddress && spenderAddress && !isNative);

  const allowanceResult = useReadContract({
    abi: erc20Abi,
    address: tokenAddress || undefined,
    functionName: 'allowance',
    args: account && spenderAddress ? [account, spenderAddress] : undefined,
    chainId,
    query: {
      refetchInterval: refetchIntervalSec ? refetchIntervalSec * 1000 : false,
      enabled,
    },
  });

  return allowanceResult.data === undefined ? undefined : String(allowanceResult.data);
};
